module.exports = __webpack_public_path__ + "img/MARIANA MONT.8b4710fd.jpeg";